import { render, staticRenderFns } from "./checkPrivacy.vue?vue&type=template&id=161297c2&scoped=true"
import script from "./checkPrivacy.vue?vue&type=script&lang=js"
export * from "./checkPrivacy.vue?vue&type=script&lang=js"
import style0 from "./checkPrivacy.vue?vue&type=style&index=0&id=161297c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161297c2",
  null
  
)

export default component.exports